<!-- requests main page -->
<template>
  <RequestsTableRedesigned
    :api-url-props="'v2/requests'"
    :have-find-request="true"
  />
</template>

<script>
import RequestsTableRedesigned from './RequestsTableRedesigned.vue'

export default {
  components: {
    RequestsTableRedesigned,
  },
}
</script>
